import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface FormFieldProps {
  id: string;
  label: string;
  required?: boolean;
  error?: string;
  hint?: React.ReactNode;
  children: React.ReactNode;
}
export function FormField({
  id,
  label,
  required = false,
  error,
  hint,
  children
}: FormFieldProps) {
  return <div data-id="element-34" data-mp="3fy9yrnyjlskr">
      <label htmlFor={id} className="block text-sm font-medium text-white" data-id="element-35" data-mp="3fyjiitszv3i0">
        {label}
        {required && <span className="ml-1 text-mist" aria-hidden="true" data-id="element-36" data-mp="3tp51sjmd1fgf">*</span>}
      </label>
      <div className="mt-2" data-id="element-37" data-mp="3po32y3wcv5ez">{children}</div>
      {error ? <p id={`${id}-error`} className="mt-2 flex items-start gap-1.5 text-sm text-alert" data-id="element-38" data-mp="7j9j5tghocdx">
          <AlertCircleIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" data-id="element-39" data-mp="2kezkpap6jsr" />
          {error}
        </p> : hint && <p id={`${id}-hint`} className="mt-2 text-xs leading-relaxed text-mist" data-id="element-40" data-mp="29bnwsgc02uoj">
            {hint}
          </p>}
    </div>;
}